module.exports = __webpack_public_path__ + "static/img/wavm8s-022-dj-mare.0730e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-022-dj-mare.png
// module id = Y9jy
// module chunks = 0